import { useTranslation } from "react-i18next";

import { BackgroundLanding } from "../../components/background";
import Header from "../../components/header";
import HeaderTitle from "../../components/header/header-title";
import Spacer from "../../components/spacer";
import { ROUTE } from "../../utils/constants";
import parse from "html-react-parser";
import MissionFooter from "../../components/missionFooter";
import Footer from "../../components/footer";
import Headline from "../../components/landing/headline";
import AboutSection from "../../components/landing/aboutSection";
import { useIsMobile } from "../../utils/isMobile";
import ProjectsRow from "../../components/landing/projectsRow";

import { projects as localProjects } from "../../data/projects";

import "./styles.css";

function AboutProjects() {
  const { t } = useTranslation();

  return (
    <div className="lp-main-about-projects">
      <span>{t("landingPage.about.projects.headline")}</span>
      <a href={ROUTE.project} className="lp-about-projects-show-projects common-button">
        {t("landingPage.about.projects.button")}
      </a>
    </div>
  );
}

function LandingPage() {
  const { t } = useTranslation();
  const projects = localProjects.slice().sort((a, b) => a.order - b.order);
  const isMobile = useIsMobile();

  return (
    <div className="App">
      <BackgroundLanding />
      <div className="landing-page-container">
        <Header />
        {!isMobile && <HeaderTitle />}
        <div className="lp-main-content-container">
          <Headline />
          <Spacer space={isMobile ? "4" : "8"} />
          <AboutSection />
          <Spacer space={isMobile ? "4" : "8"} />
          <AboutProjects />
          <Spacer space={isMobile ? "4" : "8"} />
          {!isMobile && (
            <>
              <ProjectsRow projects={projects} />
              <Spacer space="10" />
            </>
          )}
          <div className="lp-main-about-description-container">
            <div className="lp-main-about-description">
              {parse(t("landingPage.about.description"))}
              {parse(t("landingPage.about.catchPhrase"))}
            </div>
          </div>
        </div>
        <Spacer space={isMobile ? "5" : "10"} />
        <MissionFooter />
        <Footer />
      </div>
    </div>
  );
}
export default LandingPage;
